export const authQueryKeys = {
  auth: ['auth'],
};
